/**
 * Where `?next=` may send someone after they sign in.
 *
 * Anything that is not a plain path on this origin is dropped. Without this check
 * the login page is an open redirect: a link to
 * `/login?next=https://evil.example` would bounce a freshly authenticated user
 * onto someone else's site, wearing the trust of having just signed in here.
 * Protocol-relative `//host` is the same attack with shorter syntax.
 */
export function safeNextPath(next: string | undefined | null): string {
  if (!next) return "/";
  if (!next.startsWith("/")) return "/";
  if (next.startsWith("//")) return "/";
  // `\` is treated as `/` by some browsers when resolving a URL.
  if (next.startsWith("/\\")) return "/";
  return next;
}
